<template>
  <div style="padding: 24px;">
    <PageTitle class="card-title" style="font-size: 22px; margin-left: 30px;" :override_data="{ resource_type: 'Position', resource_id: position_id, company_id }" :pageTitleAdditions="{ showWhatsApp: false }"></PageTitle>
    <div class="card" style="padding: 20px; padding-right: 42px;">
      <div dir="rtl" class="columns">
        <div class="column">
          <BaseInput type="text" v-model="searchSkill" label="חיפוש סקילס :" />
        </div>
      </div>
      <div class="is-flex is-align-items-center is-justify-content-center">
        <a @click="selectImportance(2)" class="button is-info" :class="{ 'is-outlined': importance_selected != 2 }">Optional</a>
        <div style="width: 10px;"></div>
        <a @click="selectImportance(8)" class="button is-info" :class="{ 'is-outlined': importance_selected != 8 }">Mandatory</a>
        <div style="width: 10px;"></div>
        <a @click="addGroup" class="button is-info" :class="{ 'is-outlined': importance_selected != 5 }">Grouped +</a>
      </div>
      <div style="margin-top: 20px;">
        <a v-for="(position_skills, group_name) in position_skills_by_group_name"  :key="group_name" @click="selectGroup(group_name)" class="button is-danger group"
          :class="{ 'is-outlined': !isGroupSelected(group_name) }">
          {{"Group " + group_name}}
        </a>
      </div>
      <div dir="rtl" class="is-flex is-justify-content-space-between" style="margin-top: 20px;">
        <div style="width: 50%;">
          <div style="height: 20px;"></div>
          <position-skill-group @refresh="init" group_name="Optional" :position_skills="optional_position_skills" :position_id="position_id" :company_id="company_id">
          </position-skill-group>
          <div style="height: 20px;"></div>
          <position-skill-group @refresh="init" group_name="Mandatory" :position_skills="mandatory_position_skills" :position_id="position_id" :company_id="company_id">
          </position-skill-group>
          <div v-for="(position_skills, group_name) in position_skills_by_group_name" :key="group_name" style="margin-top: 20px;">
            <div v-if="position_skills.length > 0">
              <position-skill-group @refresh="init" :group_name="'Group ' + group_name" :position_skills="position_skills" :position_id="position_id" :company_id="company_id">
              </position-skill-group>
            </div>
          </div>
        </div>
        <div class="separator" style="width: 50%;">
          <div>
            <p><b>Featured</b></p>
            <div class="is-flex is-align-items-center is-flex-wrap-wrap">
              <div v-for="skill in getFeaturedSkills()" :key="skill.id">
                <position-skill v-if="skill.skill" :position_id="position_id" :company_id="company_id" :position_skill="skill" @refresh="init">
                </position-skill>
                <p v-else @click="addPositionSkill(skill)" class="skill">{{skill.name}}</p>
              </div>
            </div>
          </div>
          <hr>
          <div v-for="(skill, category) in categoriesSkills" :key="category">
            <p @click="addAllCategorySkills(category)" class="btn"><b>{{category}}</b></p>
            <div class="is-flex is-align-items-center is-flex-wrap-wrap">
              <div v-for="full_skill in categoriesSkills[category]" :key="full_skill.id">
                <p :key="full_skill.id" @click="addPositionSkill(full_skill)" class="skill">{{full_skill.name}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div dir="rtl" style="margin-top: 24px;">
        <ai-display-skills :position_id="position_id" :current_company_id="company_id" />
      </div>
    </div>
  </div>
</template>
<script>
// components
import BaseInput from '@/components/BaseInput.vue'
import PositionSkill from '@/components/PositionSkill'
import PositionSkillGroup from '@/components/PositionSkillGroup'
import PageTitle from '@/components/PageTitle'
import AiDisplaySkills from '@/components/AiDisplaySkills.vue'
export default {
  name: 'position-skills',
  props: ['payload'],
  data () {
    return {
      searchSkill: '',
      position_id: this.payload == undefined ? this.$route.query.position_id : this.payload.position_id,
      company_id: this.payload == undefined ? this.$route.query.company_id : this.payload.company_id,
      optional_position_skills: [],
      mandatory_position_skills: [],
      full_skills_by_category: [],
      position_skills_by_group_name: [],
      importance_selected: 2,
      selected_group: 1,
      position_skills: [],
      full_skills: [],
      loading: false,
      error: null
    }
  },
  created () {
    this.init()
  },
  computed: {
    categoriesSkills () {
      if (this.importance_selected == 5) {
        return this.full_skills_by_category
      }
      let categories_skills = []
      this.full_skills.filter(full_skill => {
        for (let j = 0; j < this.position_skills.length; j++) {
          let position_skill = this.position_skills[j]
          if (full_skill.id == position_skill.skill.id) {
            return
          }
        }
        categories_skills.push(full_skill)
      })
      const skills = this.organizeSkillsByCategory(categories_skills)
      return this.deepSearch(skills, this.searchSkill)
    }
  },
  methods: {
    deepSearch (obj, search) {
      return Object.fromEntries(Object.entries(obj).reduce((prev, [key, val]) => {
        if (key.includes(search)) {
          return [...prev, [key, val]]
        }
        const filtered_skills = val.filter(e => e.name.includes(search))
        if (filtered_skills.length > 0) {
          return [...prev, [key, filtered_skills]]
        }
        return prev
      }, []).map(([k, v]) => ([k, v.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))])))
    },
    init () {
      this.getPositionSkills()
      this.getFullSkills()
    },
    getPositionSkills () {
      this.loading = true
      this.error = null
      this.$network_utils.getPositionSkills({ position_id: this.position_id, current_company_id: this.company_id }).then(response => {
        this.position_skills = response || []
        this.optional_position_skills = this.position_skills.filter(position_skill => position_skill.importance == 2)
        this.mandatory_position_skills = this.position_skills.filter(position_skill => position_skill.importance == 8)
        this.position_skills_by_group_name = this.getPositionSkillsByGroupNames(this.position_skills)
        this.loading = false
      }).catch(error => {
        console.error('Error loading position skills:', error)
        this.error = 'Failed to load position skills'
        this.loading = false
        this.position_skills = []
        this.optional_position_skills = []
        this.mandatory_position_skills = []
        this.position_skills_by_group_name = []
      })
    },
    getPositionSkillsByGroupNames (position_skills) {
      let position_skills_by_group_name = {}
      position_skills.map(position_skill => {
        if (position_skill.importance != 5) {
          return
        }
        let group_name = position_skill.group_name
        if (position_skills_by_group_name[group_name] == undefined) {
          position_skills_by_group_name[group_name] = []
        }
        position_skills_by_group_name[group_name].push(position_skill)
      })
      return position_skills_by_group_name
    },
    addGroup () {
      this.selectImportance(5)
      let next_group = this.getLastGroup() + 1
      this.position_skills_by_group_name[next_group] = []
      this.selected_group = next_group
      this.$forceUpdate()
    },
    getFullSkills () {
      return this.$network_utils.getAllSkills({ sort: '-positions_prevalence' }).then(response => {
        this.full_skills = response
        this.full_skills_by_category = this.organizeSkillsByCategory(response)
      })
    },
    getLastGroup () {
      let group_names = Object.keys(this.position_skills_by_group_name)
      if (group_names.length == 0) {
        return 0
      }
      let last_index = group_names.length - 1
      return group_names[last_index] * 1
    },
    selectGroup (group_name) {
      this.selectImportance(5)
      this.selected_group = group_name
    },
    isGroupSelected (group_name) {
      if (this.importance_selected != 5) {
        return false
      }
      return this.selected_group == group_name
    },
    addAllCategorySkills (category) {
      let skills = this.full_skills_by_category[category]
      for (let i = 0; i < skills.length; i++) {
        this.addPositionSkill(skills[i])
      }
    },
    async addPositionSkill (skill) {
      let request_data = {
        skill_id: skill.id,
        position_id: this.position_id,
        current_company_id: this.company_id,
        min_experience: 0,
        importance: this.importance_selected,
        ...(this.importance_selected == 5 && { group_name: this.selected_group })
      }
      await this.$network_utils.updatePosition({ position_id: this.position_id, active_at: new Date() })
      this.$network_utils.postPositionSkill(request_data).then(() => {
        this.init()
      })
    },
    selectImportance (importance) {
      this.importance_selected = importance
    },
    organizeSkillsByCategory (skills) {
      return skills.reduce((prev, curr) => {
        const category = curr.category || curr.skill.category
        prev[category] = prev[category] || []
        prev[category].push(curr)
        return prev
      }, Object.create(null))
    },
    getFeaturedSkills () {
      let featured_position_skills = this.position_skills.filter(position_skill => position_skill.skill.featured).filter(el => el.skill.name.includes(this.searchSkill))
      let featured_full_skills = this.full_skills.filter(full_skill => {
        if (!full_skill.featured) {
          return
        }
        for (let j = 0; j < featured_position_skills.length; j++) {
          let featured_position_skill = featured_position_skills[j]
          if (featured_position_skill.skill.id == full_skill.id) {
            return
          }
        }
        return full_skill
      }).filter(el => el.name.includes(this.searchSkill))
      return [...featured_position_skills, ...featured_full_skills]
    }
  },
  components: {
    PositionSkill,
    PositionSkillGroup,
    BaseInput,
    PageTitle,
    AiDisplaySkills
  }
}
</script>
<style scoped>
  .separator{
    padding-right: 30px;
    border-right: 2px solid rgba(0, 0, 0, 0.1);
  }
  .group{
    margin-right: 10px;
  }
  .skill{
    cursor: pointer;
    margin: 0;
    margin-left: 10px;
  }
</style>
